import { Link } from "@/lib/router-compat";
import { ChevronRight, Home } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  to?: string; // ausente no item atual
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  /** usar em seções com fundo escuro */
  dark?: boolean;
}

/**
 * Trilha de navegação visual (combina com o schema BreadcrumbList já emitido
 * pelas páginas). Melhora UX e distribui autoridade entre as páginas.
 */
export function Breadcrumbs({ items, dark = false }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs sm:text-sm">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-1.5 min-w-0">
              {i > 0 && (
                <ChevronRight
                  className={`w-3.5 h-3.5 flex-shrink-0 ${dark ? "text-white/40" : "text-muted-foreground/60"}`}
                  aria-hidden="true"
                />
              )}
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className={`inline-flex items-center gap-1.5 transition-colors ${
                    dark
                      ? "text-white/60 hover:text-white"
                      : "text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {i === 0 && <Home className="w-3.5 h-3.5" aria-hidden="true" />}
                  <span className="truncate max-w-[180px] sm:max-w-none">{item.label}</span>
                </Link>
              ) : (
                <span
                  aria-current={isLast ? "page" : undefined}
                  className={`truncate max-w-[220px] sm:max-w-[360px] font-medium ${
                    dark ? "text-white" : "text-foreground"
                  }`}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
